"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.tooltips.talk': '与此头像开始对话',
    'avatar.tooltips.preview': '预览头像详情',
    'avatar.tooltips.edit': '编辑头像设置',
    'avatar.tooltips.delete': '删除此头像',
};
